window.addEventListener("DOMContentLoaded", function () {
  const videos = document.querySelectorAll(".more-video");

  // Vimeo api
  var firstScriptTag = document.getElementsByTagName("script")[0];
  var vimeoTag = document.createElement("script");
  vimeoTag.src = "https://player.vimeo.com/api/player.js";
  firstScriptTag.parentNode.insertBefore(vimeoTag, firstScriptTag);
  var vimeoPlayer;

  // Pause video function
  // function pauseVideo(currentVideo) {
  //   if (currentVideo.classList.contains("autoplay")) {
  //     iframe = currentVideo;
  //   } else {
  //     iframe = currentVideo.querySelector("iframe");
  //   }
  //   let src = iframe.getAttribute("src");

  //   // if youtube
  //   if (src.includes("youtube.com")) {
  //     // iframe.src = "";
  //   }
  //   // if vimeo
  //   else if (src.includes("vimeo.com")) {
  //     if (!vimeoPlayer) {
  //       vimeoPlayer = new Vimeo.Player(iframe);
  //     }
  //     // if internal
  //     vimeoPlayer.pause();
  //   }
  // }

  videos.forEach((video) => {
    if (video.classList.contains("autoplay")) {
      let videoType = video.dataset.type;
      let videoId = video.dataset.videoid;
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              if (videoType == "youtube") {
                video.src = `https://www.youtube.com/embed/${videoId}?rel=0&amp;autoplay=1&mute=1&loop=1&controls=0&enablejsapi=1&playlist=${videoId}`;
              } else if (videoType == "vimeo") {
                video.src = `https://player.vimeo.com/video/${videoId}?autoplay=1&loop=1&autopause=0&muted=0&controls=1`;
              }
            } else {
              pauseVideo(video);
            }
          });
        },
        { threshold: 0.5 }
      );

      observer.observe(video);
    }
  });

  function pauseVideo(currentVideo) {
    let iframe;
    if (currentVideo.tagName === "IFRAME") {
      iframe = currentVideo;
    } else if (currentVideo.classList.contains("autoplay")) {
      iframe = currentVideo;
    } else {
      iframe = currentVideo.querySelector("iframe");
    }
    if (!iframe) return;
    let src = iframe.getAttribute("src") || "";

    // YouTube
    if (src.includes("youtube.com")) {
      iframe.contentWindow.postMessage(
        JSON.stringify({
          event: "command",
          func: "pauseVideo",
          args: [],
        }),
        "*"
      );
    }
    // Vimeo
    else if (src.includes("vimeo.com")) {
      if (typeof Vimeo !== "undefined") {
        let vimeoPlayer = new Vimeo.Player(iframe);
        vimeoPlayer.pause();
      }
    }
  }

  function playVideo(currentVideo) {
    let iframe;
    if (currentVideo.tagName === "IFRAME") {
      iframe = currentVideo;
    } else if (currentVideo.classList.contains("autoplay")) {
      iframe = currentVideo;
    } else {
      iframe = currentVideo.querySelector("iframe");
    }
    if (!iframe) return;
    let src = iframe.getAttribute("src") || "";

    // YouTube
    if (src.includes("youtube.com")) {
      iframe.contentWindow.postMessage(
        JSON.stringify({
          event: "command",
          func: "playVideo",
          args: [],
        }),
        "*"
      );
    }
    // Vimeo
    else if (src.includes("vimeo.com")) {
      if (typeof Vimeo !== "undefined") {
        let vimeoPlayer = new Vimeo.Player(iframe);
        vimeoPlayer.play();
      }
    }
  }

  document
    .querySelectorAll(".slide-video-controls")
    .forEach(function (control) {
      const blockId = control.getAttribute("data-video-block");
      // Find the video container in the same slide
      const slide = control.closest(".swiper-slide");
      if (!slide) return;

      // Try to find the video container (for click-to-play/modal) or iframe (for autoplay)
      let videoContainer =
        slide.querySelector(".more-video") ||
        slide.querySelector(".video-external-container.autoplay") ||
        slide.querySelector("iframe.external-video");

      if (!videoContainer) return;

      // Play button
      const playBtn = control.querySelector(".video-play");
      if (playBtn) {
        playBtn.addEventListener("click", function () {
          playVideo(videoContainer);
        });
      }

      // Pause button
      const pauseBtn = control.querySelector(".video-pause");
      if (pauseBtn) {
        pauseBtn.addEventListener("click", function () {
          pauseVideo(videoContainer);
        });
      }
    });
});

function handleClick(e) {
  // Play type is modal
  let currentVideo = e.currentTarget;
  console.log(currentVideo);

  if (currentVideo.classList.contains("video-modal-trigger")) {
    // Grab everything needed for the modal
    let modal = currentVideo.querySelector(".video-modal");
    let topLayer = currentVideo.querySelector(".top-layer");
    let iframe = currentVideo.querySelector("iframe");

    // If the modal is not already open, open it
    if (!modal.classList.contains("video-modal-visible")) {
      modal.classList.add("video-modal-visible");
      topLayer.classList.add("hidden");
      // Youtube api workaround
      if (iframe && iframe.classList.contains("youtube-video")) {
        let videoId = iframe.getAttribute("data-videoid");
        iframe.src = `https://www.youtube.com/embed/${videoId}?rel=0&autoplay=1&loop=1&enablejsapi=1&playlist=${videoId}`;
      }
    } else {
      // Close modal and pause video
      modal.classList.remove("video-modal-visible");
      topLayer.classList.remove("hidden");
      pauseVideo(currentVideo);
    }

    // Close modal on escape key
    document.addEventListener("keydown", function (event) {
      if (
        event.key === "Escape" &&
        modal.classList.contains("video-modal-visible")
      ) {
        modal.classList.remove("video-modal-visible");
        topLayer.classList.remove("hidden");
        pauseVideo(currentVideo);
      }
    });

    let lightboxClose = document.querySelector(".lightbox-close");
    if (lightboxClose) {
      lightboxClose.addEventListener("click", function () {
        modal.classList.remove("video-modal-visible");
        topLayer.classList.remove("hidden");
        pauseVideo(currentVideo);
      });
    }
  } else {
    e.preventDefault();

    // Click to play
    let currentVideo = e.currentTarget;
    let topLayer = currentVideo.querySelector(".top-layer");
    let front = currentVideo.querySelector(".front");
    let poster = currentVideo.querySelector(".image-container");
    let videoWrapper = currentVideo.querySelector(".video-wrapper");
    let iframe = videoWrapper.querySelector("iframe");
    let videoType = iframe.dataset.type;
    let videoId = iframe.dataset.videoid;
    let back = currentVideo.querySelector(".back");
    let swiperChange = document.querySelectorAll(".swiper-button");

    if (swiperChange) {
      swiperChange.forEach((button) => {
        button.addEventListener("click", function () {
          back.classList.add("invisible");
          back.classList.add("hidden");
          topLayer.classList.remove("full");
          front.classList.remove("hidden");
          // pauseVideo(currentVideo);
        });
      });
    }

    // Hide cover photos
    topLayer.classList.add("full");
    front.classList.add("hidden");
    poster.style.opacity = 0;

    // Load videos
    if (videoType == "youtube") {
      iframe.src = `https://www.youtube.com/embed/${videoId}?rel=0&autoplay=1&mute=1&enablejsapi=1&loop=1&controls=1&playlist=${videoId}`;
    } else if (videoType == "vimeo") {
      iframe.src = `https://player.vimeo.com/video/${videoId}?autoplay=1&loop=1&autopause=0&muted=0&controls=1`;
    }
    https: setTimeout(function () {
      back.classList.remove("hidden");
      back.classList.remove("invisible");
    }, 600);
  }
}
